<template>
  <div class="loginWrapper">
    <div class="containerSingleBox">
      <!--Login box -->
      <div class="loginBox background-white">
        <div class="logo">
          <img src="@/assets/images/up.png" />
          <br />
          <br />
          <h2 v-if="!this.resetComplete">{{ $t("forgotPasswordTitle") }}</h2>
          <p
            class="lightGrey"
            v-if="!this.resetComplete && !otpBool && !otp_password"
            v-html="$t('forgotPasswordMessage')"
          ></p>
          <p
            class="lightGrey"
            v-if="!this.resetComplete && otpBool"
            v-html="$t('forgotPasswordMessageOTP')"
          ></p>
          <p class="loginError" v-if="this.registrationError !== null" v-html="getErrorMessage()">
            <!-- <span v-if="this.registrationError.code === 'PSB1' || this.registrationError.code === 'PSB2' || this.registrationError.code === 'PSB3'" ></span>
            <span v-else>{{ this.registrationError.description }}</span> -->
          </p>
        </div>

        <div class="loginForm">
          <form @submit.prevent="confirmPasswordReset">
            <div
              v-if="
                (this.newPasswordData == null) & !this.resetComplete && !otpBool
              "
            >
              <input
                type="text"
                :placeholder="[[$t('emailField')]]"
                id="input-email"
                v-model="formData.email"
                :style="validateEmailClass"
                required
              />
              <!-- <input
                type="text"
                :placeholder="[[$t('registrationCodeFieldLabel')]]"
                id="input-passs-token"
                v-model="formData.pass_token"
                required
              /> -->
              <input
                type="button"
                :value="[[$t('confirmButtonLabel')]]"
                variant="primary"
                class="submitCompanies"
                @click="validateUserAccount"
              />
            </div>
            <div
              v-if="
                (this.newPasswordData != null) & !this.resetComplete 
              "
            >
            <p v-if="otpResendSuccess" class="lightGrey text-center">
                {{ $t("msgEmailSuccess") }}
              </p>
            <input
                type="text"
                :placeholder="[[$t('otpField')]]"
                id="input-otp"
                v-model="otp_password"
                :style="validateEmailClass"
                required
              />
              <p class="text-right">
                <a href="#" class="link" @click="resendOtp()">{{
                  $t("otpResendText")
                }}</a>
              </p>
              <input
                type="password"
                :placeholder="[[$t('passwordField')]]"
                v-model="newPasswordData.new_password"
                @input="validatePassword"
                required
              />
              <input
                type="password"
                :placeholder="[[$t('confirmPasswordField')]]"
                required
                :style="confirmPasswordStyle"
                @input="validatePassword"
                v-model="confirmPassword"
              />
              <password
                v-model="newPasswordData.new_password"
                :strength-meter-only="true"
              />
              <div class="passwordConditions">
                <p>
                  <img
                    v-if="!isIE"
                    :src="
                      this.validPassword.passwordLengthValid
                        ? require('../../assets/images/yes.png')
                        : require('../../assets/images/no.png')
                    "
                  />
                  &nbsp; Minimum 8 characters
                </p>
                <p>
                  <img
                    v-if="!isIE"
                    :src="
                      this.validPassword.containsLetter
                        ? require('../../assets/images/yes.png')
                        : require('../../assets/images/no.png')
                    "
                  />&nbsp; At least one letter character
                </p>
                <p>
                  <img
                    v-if="!isIE"
                    :src="
                      this.validPassword.containsNumber
                        ? require('../../assets/images/yes.png')
                        : require('../../assets/images/no.png')
                    "
                  />&nbsp; At least one numeric digit
                </p>
              </div>
              <br />
              <br />
              <input
                type="submit"
                :value="[[$t('confirmButtonLabel')]]"
                variant="primary"
                class="submitCompanies"
              />
            </div>
            <!-- Begin congrats -->
            <div class="loginForm" v-if="this.resetComplete">
              <form @submit.prevent="completePasswordReset" align="center">
                <img src="../../assets/images/congrats.png" />

                <h2 align="center">{{ $t("successMessageTitle") }}</h2>
                <p align="center" class="lightGrey">
                  {{ $t("resetPasswordSuccessMessage") }}
                </p>
                <input type="submit" value="CONFIRM" class="submitCompanies" />
              </form>
            </div>
            <!-- End congrats -->
          </form>
        </div>
      </div>
      <!--End Login box -->
    </div>
  </div>
</template>

<script>
import validator from "../../plugins/fieldValidation";
import httpService from "../../http/http-common.js";
import Password from "vue-password-strength-meter";
import $ from "jquery";

export default {
  components: { Password },
  name: "forgot_password",
  props: {
    msg: String,
  },
  data() {
    return {
      formData: {
        email: "",
        pass_token: "",
      },
      token: "",
      registrationError: null,
      newPasswordData: null,
      confirmPassword: "",
      validPassword: {
        passwordValid: false,
        passwordLengthValid: false,
        containsLetter: false,
        containsNumber: false,
        confirmPasswordValid: false,
      },
      resetComplete: false,
      isIE: false,
      config: null,
      otpBool: false,
      otp_password: null,
      otp_resend: false, //
      otpResendSuccess: false,
    };
  },
  methods: {
    validateUserAccount() {
      this.otpBool = false;
      if (validator.validateEmail(this.formData.email)) {
        // if the email address is correct
        httpService.companyService
          .userCheckForPasswordReset(this.formData, this.token)
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            return error.response;
          })
          .then((response) => {
            if (response.status == 200) {
              this.newPasswordData = response.data;
              this.registrationError = null;
              this.otpBool = true;
            } else if (response.status == 400 || response.status == 403) {
              this.newPasswordData = null;
              this.registrationError = {
                code: response.data.error_code,
                description: response.data.error_params ? response.data.error_params : response.data.description
              };
            } else {
              this.newPasswordData = null;
              this.registrationError = { description: response.code };
            }
          });
      } else {
        this.error = {
          description: "Invalid email",
          code: "",
        };
      }
    },
    // validateOtp() {
    //   let otpData = {
    //     ...this.newPasswordData,
    //     otp_password: this.otp_password,
    //   };

    //   httpService.companyService
    //     .validateOtp(otpData, this.token)
    //     .then((response) => {
    //       if (response.status == 200) {
    //         this.otpBool = false;
    //       } else if (response.status == 400 || response.status == 403) {
    //         this.registrationError = {
    //           code: response.data.error_code,
    //           description: response.data.error_params ? response.data.error_params : response.data.description
    //         };
    //       } else {
    //         this.registrationError = { description: response.code };
    //       }
    //     })
    //     .catch((error) => {
    //       if (error.response.status == 400 || error.response.status == 403) {
    //         this.registrationError = {
    //           code: error.response.data.error_code,
    //           description: error.response.data.error_params ? error.response.data.error_params : error.response.data.description
    //         };
    //       } else if (error.response.status == 500 ){
    //         this.registrationError = {
    //           code: "ISSS",
    //           description: this.config.errors["ISSS"],
    //         };
    //       } else {
    //         this.registrationError = {
    //           code: error.response.status,
    //           description: error.response.data
    //         }
    //       }
    //     });
    resendOtp() {
      let otpData = {
        ...this.newPasswordData,
        otp_resend: true,
      };
      this.otpResendSuccess = false;

      httpService.companyService
        .validateOtp(otpData, this.token)
        .then((response) => {
          if (response.status == 200) {
            this.otpResendSuccess = true;
          } else if (response.status == 400 || response.status == 403) {
            this.registrationError = {
              code: response.data.error_code,
              description: response.data.description,
            };
          } else {
            this.registrationError = { description: response.code };
          }
        })
        .catch((error) => {
          return error.response;
        });
    },
    validatePassword() {
      this.validPassword = validator.validatePassword(
        this.newPasswordData.new_password,
        this.confirmPassword
      );
    },

    confirmPasswordReset() {
      if (!this.validPassword.passwordValid) {
        this.registrationError = {
          description: "Invalid password",
          code: "",
        };
        return;
      } else {
        this.newPasswordData.otp_password = this.otp_password;
        httpService.companyService
          .resetBeneficiaryPassword(this.newPasswordData, this.token)
          .then(function (response) {
            // handle success
            return response;
          })
          .catch((error) => {
            // handle error
            this.registrationError = error.response.data;
            return error.response;
          })
          .then((response) => {
            if (response.status == 200) {
              this.registrationError = null;
              this.resetComplete = true;
              // do congrats
            } else if (response.status == 400) {
              this.registrationError = response.data;
            } else {
              this.registrationError = { description: response.code };
            }
          });
      }
    },
    completePasswordReset() {
      this.newPasswordData = null;
      this.token = "";
      this.confirmPassword = "";
      this.registrationError = null;
      this.validPassword = null;
      this.formData = null;
      this.resetComplete = false;

      this.$router.push({ name: "login", params: { loginUserSelected: true } });
    },
    checkLoginPage() {
      if (!$("body").hasClass("login-pages")) {
        $("body").addClass("login-pages");
      } else {
        $("body").removeClass("login-pages");
      }
    },
    getErrorMessage() {
      if (this.registrationError.description) {
        try {
          let description = this.registrationError.description;
          if (Array.isArray(description)) {
            if (description.length > 1) {
              return this.$t("errorMessage_" + this.registrationError.code, {
                param: description[0],
                param1: description[1]
              });
            } else {
              return this.$t("errorMessage_"  + this.registrationError.code, {
                param: description[0]
              });
            }
          } else {
            return this.config.errors[this.registrationError.code]
          }
        } catch {
          return this.config.errors[this.registrationError.code]
        }
      } else {
        return this.config.errors[this.registrationError.code]
      }
    },
  },
  mounted() {
    if (!sessionStorage.getItem("club_jsonFile")) {
      httpService.commonsService
        .getConfigFile(localStorage.language, "club")
        .then(function (response) {
          return response;
        })
        .then((data) => {
          this.config = JSON.parse(
            sessionStorage.getItem("club_jsonFile")
          );
        });
    } else {
      this.config = JSON.parse(sessionStorage.getItem("club_jsonFile"));
    }
    this.isIE = /*@cc_on!@*/ false || !!document.documentMode;
    httpService.companyService
      .requestTokenForRegistration("webopen")
      .then(function (response) {
        // handle success
        return response.data;
      })
      .then((data) => {
        this.token = data.access_token;
      })
      .catch((error) => {
        // handle success
      });

    this.checkLoginPage();
  },
  computed: {
    confirmPasswordStyle() {
      return this.confirmPassword === ""
        ? ""
        : this.newPasswordData.new_password === this.confirmPassword
        ? ""
        : "outline-color: #ff0000a6;";
    },
    validateEmailClass() {
      return this.formData.email === ""
        ? ""
        : validator.validateEmail(this.formData.email)
        ? ""
        : "outline-color: #ff0000a6;  ";
    },
  },
};
</script>
<style scoped src="@/assets/styles/login.css"></style>
